var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStreamlineEmojisHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-emojis:hospital"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.15,
    d: "M4.08331 53.2833C4.08331 53.7475 6.6031 54.1926 11.0883 54.5208C15.5736 54.849 21.6569 55.0333 28 55.0333C34.3431 55.0333 40.4264 54.849 44.9116 54.5208C49.3969 54.1926 51.9166 53.7475 51.9166 53.2833C51.9166 52.8192 49.3969 52.3741 44.9116 52.0459C40.4264 51.7177 34.3431 51.5333 28 51.5333C21.6569 51.5333 15.5736 51.7177 11.0883 52.0459C6.6031 52.3741 4.08331 52.8192 4.08331 53.2833Z",
    fill: "#45413C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66669 17.7H51.3334V21.2H4.66669V17.7Z",
    fill: "#8CA4B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.1667 17.7H5.83335C5.52393 17.7 5.22718 17.8229 5.00839 18.0417C4.7896 18.2605 4.66668 18.5572 4.66668 18.8666V20.0333C4.65448 20.1301 4.65448 20.2281 4.66668 20.325C4.73282 20.0683 4.88439 19.8417 5.09645 19.6827C5.30851 19.5237 5.56841 19.4416 5.83335 19.45H50.1667C50.4316 19.4416 50.6915 19.5237 50.9036 19.6827C51.1156 19.8417 51.2672 20.0683 51.3333 20.325C51.3455 20.2281 51.3455 20.1301 51.3333 20.0333V18.8666C51.3333 18.5572 51.2104 18.2605 50.9916 18.0417C50.7728 17.8229 50.4761 17.7 50.1667 17.7Z",
    fill: "#ADC4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.66669 17.7H51.3334V21.2H4.66669V17.7Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.83331 21.2H50.1666V50.9499C50.1666 51.2594 50.0437 51.5561 49.8249 51.7749C49.6061 51.9937 49.3094 52.1166 49 52.1166H6.99998C6.69056 52.1166 6.39381 51.9937 6.17502 51.7749C5.95623 51.5561 5.83331 51.2594 5.83331 50.9499V21.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.83331 21.2H50.1666V23.825H5.83331V21.2Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.83331 21.2H50.1666V50.95C50.1666 51.2594 50.0437 51.5561 49.8249 51.7749C49.6061 51.9937 49.3094 52.1166 49 52.1166H6.99998C6.69056 52.1166 6.39381 51.9937 6.17502 51.7749C5.95623 51.5561 5.83331 51.2594 5.83331 50.95V21.2Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.75 14.7833H40.25V52.1167H15.75V14.7833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.75 14.7833H40.25V16.8717H15.75V14.7833Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.75 14.7833H40.25V52.1167H15.75V14.7833Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21 39.2833H35V52.1167H21V39.2833Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M23.8467 52.1167H29.9133L35 39.785V39.2833H29.1317L23.8467 52.1167Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21 39.2833H35V52.1167H21V39.2833Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M19.8333 35.2H36.1666V39.2833H19.8333V35.2Z",
    fill: "#8CA4B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M35 35.2H21C20.6906 35.2 20.3938 35.3229 20.175 35.5417C19.9562 35.7605 19.8333 36.0572 19.8333 36.3666V38.1166C19.828 38.1631 19.828 38.2101 19.8333 38.2566C19.8703 37.9742 20.0094 37.715 20.2243 37.5281C20.4392 37.3411 20.7151 37.2392 21 37.2416H35C35.2848 37.2392 35.5607 37.3411 35.7756 37.5281C35.9906 37.715 36.1296 37.9742 36.1667 38.2566C36.172 38.2101 36.172 38.1631 36.1667 38.1166V36.3666C36.1667 36.0572 36.0437 35.7605 35.8249 35.5417C35.6062 35.3229 35.3094 35.2 35 35.2Z",
    fill: "#ADC4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M19.8333 35.2H36.1666V39.2833H19.8333V35.2Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M14.5833 11.2833H41.4166V14.7833H14.5833V11.2833Z",
    fill: "#8CA4B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M40.25 11.2833H15.75C15.4406 11.2833 15.1438 11.4062 14.925 11.625C14.7062 11.8438 14.5833 12.1406 14.5833 12.45V13.6167C14.5902 13.716 14.6098 13.814 14.6416 13.9083C14.7054 13.6614 14.8482 13.4421 15.0484 13.2841C15.2486 13.1261 15.495 13.038 15.75 13.0333H40.25C40.5149 13.0249 40.7748 13.107 40.9869 13.2661C41.1989 13.4251 41.3505 13.6516 41.4166 13.9083C41.4288 13.8115 41.4288 13.7135 41.4166 13.6167V12.45C41.4166 12.1406 41.2937 11.8438 41.0749 11.625C40.8561 11.4062 40.5594 11.2833 40.25 11.2833Z",
    fill: "#ADC4D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M14.5833 11.2833H41.4166V14.7833H14.5833V11.2833Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M32.0833 22.3666H30.3333C30.1786 22.3666 30.0302 22.3052 29.9208 22.1958C29.8114 22.0864 29.75 21.938 29.75 21.7833V20.0333C29.75 19.8786 29.6885 19.7302 29.5791 19.6208C29.4697 19.5114 29.3214 19.45 29.1666 19.45H26.8333C26.6786 19.45 26.5302 19.5114 26.4208 19.6208C26.3114 19.7302 26.25 19.8786 26.25 20.0333V21.7833C26.25 21.938 26.1885 22.0864 26.0791 22.1958C25.9697 22.3052 25.8214 22.3666 25.6666 22.3666H23.9166C23.7619 22.3666 23.6136 22.4281 23.5042 22.5375C23.3948 22.6469 23.3333 22.7952 23.3333 22.95V25.2833C23.3333 25.438 23.3948 25.5864 23.5042 25.6958C23.6136 25.8052 23.7619 25.8666 23.9166 25.8666H25.6666C25.8214 25.8666 25.9697 25.9281 26.0791 26.0375C26.1885 26.1469 26.25 26.2952 26.25 26.45V28.2C26.25 28.3547 26.3114 28.503 26.4208 28.6124C26.5302 28.7218 26.6786 28.7833 26.8333 28.7833H29.1666C29.3214 28.7833 29.4697 28.7218 29.5791 28.6124C29.6885 28.503 29.75 28.3547 29.75 28.2V26.45C29.75 26.2952 29.8114 26.1469 29.9208 26.0375C30.0302 25.9281 30.1786 25.8666 30.3333 25.8666H32.0833C32.238 25.8666 32.3864 25.8052 32.4958 25.6958C32.6052 25.5864 32.6666 25.438 32.6666 25.2833V22.95C32.6666 22.7952 32.6052 22.6469 32.4958 22.5375C32.3864 22.4281 32.238 22.3666 32.0833 22.3666Z",
    fill: "#FF6242",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M9.33331 24.1166H12.25V29.3666H9.33331V24.1166Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M9.91668 29.3666H11.6667C11.8214 29.3666 11.9698 29.3052 12.0792 29.1958C12.1886 29.0864 12.25 28.938 12.25 28.7833V24.7C12.2467 24.5724 12.2016 24.4495 12.1217 24.35L9.53168 29.215C9.63657 29.3118 9.77391 29.3659 9.91668 29.3666Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M9.33331 32.2833H12.25V37.5333H9.33331V32.2833Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M9.91668 37.5333H11.6667C11.8214 37.5333 11.9698 37.4718 12.0792 37.3624C12.1886 37.253 12.25 37.1046 12.25 36.9499V32.8666C12.2467 32.739 12.2016 32.6161 12.1217 32.5166L9.53168 37.3816C9.63657 37.4785 9.77391 37.5326 9.91668 37.5333Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M9.33331 40.45H12.25V45.7H9.33331V40.45Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M9.91668 45.6999H11.6667C11.8214 45.6999 11.9698 45.6384 12.0792 45.529C12.1886 45.4196 12.25 45.2713 12.25 45.1166V41.0332C12.2467 40.9057 12.2016 40.7827 12.1217 40.6832L9.53168 45.5482C9.63657 45.6451 9.77391 45.6992 9.91668 45.6999Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M9.33331 24.1166H12.25V29.3666H9.33331V24.1166ZM9.33331 32.2832H12.25V37.5332H9.33331V32.2832ZM9.33331 40.4499H12.25V45.6999H9.33331V40.4499Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M43.75 24.1166H46.6667V29.3666H43.75V24.1166Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M44.3333 29.3666H46.0833C46.238 29.3666 46.3864 29.3052 46.4958 29.1958C46.6052 29.0864 46.6666 28.938 46.6666 28.7833V24.7C46.6633 24.5724 46.6182 24.4495 46.5383 24.35L43.9483 29.215C44.0532 29.3118 44.1905 29.3659 44.3333 29.3666Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M43.75 32.2833H46.6667V37.5333H43.75V32.2833Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M44.3333 37.5333H46.0833C46.238 37.5333 46.3864 37.4718 46.4958 37.3624C46.6052 37.253 46.6666 37.1046 46.6666 36.9499V32.8666C46.6633 32.739 46.6182 32.6161 46.5383 32.5166L43.9483 37.3816C44.0532 37.4785 44.1905 37.5326 44.3333 37.5333Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M43.75 40.45H46.6667V45.7H43.75V40.45Z",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M44.3333 45.6999H46.0833C46.238 45.6999 46.3864 45.6384 46.4958 45.529C46.6052 45.4196 46.6666 45.2713 46.6666 45.1166V41.0332C46.6633 40.9057 46.6182 40.7827 46.5383 40.6832L43.9483 45.5482C44.0532 45.6451 44.1905 45.6992 44.3333 45.6999Z",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M28 39.2832V52.1166M43.75 24.1166H46.6667V29.3666H43.75V24.1166ZM43.75 32.2832H46.6667V37.5332H43.75V32.2832ZM43.75 40.4499H46.6667V45.6999H43.75V40.4499Z",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineEmojisHospital);
export default __webpack_public_path__ + "static/media/streamline-emojis_hospital.755005c7ae2ebb961af048dce0413b84.svg";
export { ForwardRef as ReactComponent };